// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_broadcasts_edges_node_activityReport(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ActivityReportV5"]);
}

let fragmentConverter = {"__root":{"broadcasts_edges_node_activityReport":{"u":"fragment_broadcasts_edges_node_activityReport"}}};

let fragmentConverterMap = {
  fragment_broadcasts_edges_node_activityReport: unwrap_fragment_broadcasts_edges_node_activityReport
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "PropertyBroadcastConnection",
      "kind": "LinkedField",
      "name": "broadcasts",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "PropertyBroadcastEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "ForSalePropertyBroadcast",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "activityReport",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v0/*: any*/)
                            ],
                            "type": "ActivityReportV5",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": "broadcasts(first:1)"
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};
})());

let wrap_fragment_broadcasts_edges_node_activityReport = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_broadcasts_edges_node_activityReport = unwrap_fragment_broadcasts_edges_node_activityReport;
exports.wrap_fragment_broadcasts_edges_node_activityReport = wrap_fragment_broadcasts_edges_node_activityReport;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
